import { CategoricalData, OutcomeAnalysisBenefitTakeupGraphRequest } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import outcomeTrackerAdaptRequest, { OutcomeTrackerAdaptRequestProps } from './outcomeTrackerAdaptRequest';

export default class PostBenefitTakeupGraph extends BaseAdapter<CategoricalData[]> {
  modifiedRequest: OutcomeAnalysisBenefitTakeupGraphRequest;

  async adaptResponse(request: OutcomeTrackerAdaptRequestProps, benefitId: string): Promise<CategoricalData[]> {
    const formattedRequest = this.adaptRequest(request, benefitId);
    await this.fetchApiResponse('/api/outcome-tracker/benefit-takeup/graph', HTTPMethod.Post, formattedRequest);
    return this.rawResponse;
  }

  adaptRequest(request: OutcomeTrackerAdaptRequestProps, benefitId: string): OutcomeAnalysisBenefitTakeupGraphRequest {
    this.modifiedRequest = {
      benefit_id: benefitId,
      ...outcomeTrackerAdaptRequest(request)
    };
    return this.modifiedRequest;
  }
}
